<template>
  <qx-card title="报备信息">
    <qx-detail-box :data="listInfo" />
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  orderTimeReportList,
} from 'api/operate';
export default {
  mixins: [
    tableMixin,
  ],
  data () {
    return {
      listInfo: {
        label: '报备信息',
        type: 'array',
        tableData: {
          title: [
            {
              prop: 'createDate',
              label: '报备时间',
            },
            {
              prop: 'reportTypeName',
              label: '报备类型',
            },
            {
              prop: 'reportDesc',
              label: '详细描述',
            },
            {
              prop: 'imgUrlArr',
              label: '附件',
              type: 'img',
              isArray: true,
            },
          ],
          data: {

          },
          approveData: {

          },
        },
      },
    };
  },
  methods: {
    async getData () {
      const res = await orderTimeReportList({
        orderId: this.$route.query.id,
      });
      this.listInfo.tableData.data = res.items;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
